<template>
    <div class="detail">
      <div class="navbar">
        <span @click="routerTo('/pcpage/home')"> < 首页</span> / 图片故事 /
        {{ detail.category_name }}#{{ detail.topic_name }}
      </div>
      <div class="comment" v-if="detail.comment_one">
        <div class="commentTitle">
          评委点评
        </div>
        <div class="commentCon">
          <div>
            {{detail.comment_one}}
          </div>
          <div>
            {{detail.comment_two}}
          </div>
        </div>
      </div>
      <div class="content">
        
        <div class="coverCon">
          <img :src="'https://collection2021-cos.chineseplus.net/'+detail.cover" alt="" class="cover">
        </div>
        <div class="infoContent">
          <div class="title">
            {{detail.title}}
          </div>
          <div class="info">
            <div class="left">
              <div class="user">
                {{detail.user_name}}
              </div>
              <div class="country">
                {{detail.cn}}
              </div>
            </div>
            <div class="right" @click="boost">
              <img src="../img/zan_1.png" alt="">
              <span class="num" v-if="!isShowZAN">{{detail.like_num}}</span>
              <span class="num" v-if="isShowZAN">+1</span>
            </div>
          </div>
          <div class="desc">
            {{detail.desc}}
          </div>
        </div>
      </div>
      <div class="thumbCon">
        <div class="thumb">
          <div class="topThumb">
            <swiper class="swiper gallery-top" :options="swiperOptionTop" ref="swiperTop">
            <swiper-slide class="slide-1" v-for="item in detail.photo_list" :key="item.photo_id">
              <div>
                <!-- <img :src="'https://collection2021-cos.chineseplus.net/'+item.photo_cover" alt=""> -->
                <el-image
                  style="width: 1080px;height: 840px"
                  :src="'https://collection2021-cos.chineseplus.net/'+item.photo_cover"
                  fit="contain"></el-image>
              </div>
              <div class="photoDesc">
                {{item.photo_desc}}
              </div>
            </swiper-slide>
            
            </swiper>
            <div class="swiper-button-next " slot="button-next"></div>
            <div class="swiper-button-prev " slot="button-prev"></div>
          </div>
          
        <!-- swiper2 Thumbs -->
        <div class="gallery-thumbs-con">
          <swiper class="swiper gallery-thumbs" :options="swiperOptionThumbs" ref="swiperThumbs">
            <swiper-slide class="" v-for="item in detail.photo_list" :key="item.photo_id">
              <!-- <img :src="'https://collection2021-cos.chineseplus.net/'+item.photo_cover" alt=""> -->
              <el-image
                  style="width: 212px;height: 129px"
                  :src="'https://collection2021-cos.chineseplus.net/'+item.photo_cover"
                  fit="contain"></el-image>
            </swiper-slide>
          </swiper>
        </div>
        
        </div>
      </div>

    </div>
</template>

<script>
export default {
    name: 'vlogdetail',
    components: {
      
    },
    data: function () {
        return {
          swiperOptionTop: {
            loop: true,
            loopedSlides: 5, // looped slides should be the same
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            }
          },
          swiperOptionThumbs: {
            loop: true,
            loopedSlides: 5, // looped slides should be the same
            spaceBetween: 10,
            centeredSlides: true,
            
            slidesPerView: 5,
            touchRatio: 0.2,
            slideToClickedSlide: true
          },
          detail: {

          },
          isShowZAN: false
        }
    },
    created() {
      var id = this.$route.query.id
      this.getDetail(id)
    },
    mounted() {
      this.$nextTick(() => {
        const swiperTop = this.$refs.swiperTop.swiper
        const swiperThumbs = this.$refs.swiperThumbs.swiper
        swiperTop.controller.control = swiperThumbs
        swiperThumbs.controller.control = swiperTop
      })
    },
    methods: {
      routerTo(path) {
        this.$router.push(path);
      },
      // 登录
      loginFun () {
        const currentUrl = window.location.href
        window.location.href = 'https://collection2021.chineseplus.net/user/login?callback=' + currentUrl
      },
      boost() {
        return false
        this.$utils.postJson('/vote/api/likeWorks', {
          works_id: this.detail.works_id
        }).then(res => {
          if(res.code == 1000) {
            this.isShowZAN = true
            this.$message({
              message: '您的选票已进入后台审核，稍后请刷新查看最新票数',
              type: "success",
            })
          }else if(res.code == 1002) {
            this.$confirm('当前未登录，前往登录？', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loginFun()
            })
          } else {
            this.$message({
              message: res.msg,
              type: "warning",
            })
          }
          
        })
      },
      getDetail(id) {
        if(id) {
          this.$utils.get('/works/getInfo', {
            works_id: id
          }).then(res => {
            this.detail = res.data
          })
        }
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.detail {
    width: 1200px;
    margin: 50px auto;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .navbar {
      font-size: 24px;
      color: #0b2ab0;
      span {
        cursor: pointer;
      }
    }
    .comment {
      width: 1200px;
      padding: 31px 36px;
      background-color: rgba(#fff, 0.8);
      margin-top: 60px;
      box-sizing: border-box;
      .commentTitle {
        position: relative;
        top: -70px;
        width: 405px;
        height: 70px;
        line-height: 65px;
        margin: auto;
        background-image: linear-gradient(0deg, 
          #746bef 0%, 
          #728bf9 100%);
        border-radius: 35px;
        text-align: center;
        font-size: 50px;
        color: #fff;
        font-weight: bold;
        &:before {
          position: absolute;
          left: -60px;
          top: 15px;
          content: '';
          display: inline-block;
          width: 60px;
          height: 60px;
          background-image: url(../img/left.png);
          background-repeat: no-repeat;
        }
        &:after {
          position: absolute;
          right: -80px;
          top: 15px;
          content: '';
          display: inline-block;
          width: 60px;
          height: 60px;
          background-image: url(../img/right.png);
          background-repeat: no-repeat;
        }
      }
      .commentCon {
        margin-top: -30px;
        font-size: 20px;
        div {
          margin-bottom: 5px;
          line-height: 1.2;
        }
      }
    }
    .content {
      width: 1200px;
      padding: 31px 36px;
      background-color: rgba(#fff, 0.8);
      margin-top: 60px;
      box-sizing: border-box;
      
      .coverCon {
        display: inline-block;
        width: 360px;
        height: 231px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .infoContent {
        width: 740px;
        height: 231px;
        display: inline-block;
        vertical-align: top;
        margin-left: 20px;
        .title {
          width: 740px;
          margin: auto;
          font-size: 36px;
        }
        .info {
          width: 740px;
          height: 60px;
          margin: auto;
          margin-top: 15px;
          .left {
            display: inline-block;
            .user,.country {
              font-size: 20px;
              color: #666;
              line-height: 1.2;
              margin-top: 5px;
            }
          }
          .right {
            float: right;
            display: inline-block;
            // min-width: 171px;
            height: 60px;
            line-height: 60px;
            text-align: center;
            // border: 1px solid #f64109;
            // border-radius: 30px;
            // background-color: #eb9b08;
            // cursor: pointer;
            img {
              vertical-align: middle;
              margin-left: 20px;
              margin-top: 10px;
              float: left;
            }
            .num {
              font-size: 36px;
              color: #ff0707;
              margin: 0 20px;
            }
          }
        }
        .desc {
          width: 740px;
          font-size: 18px;
          color: #242424;
          line-height: 1.2;
          margin-top: 20px;
        }
      }
    }
}
.thumbCon {
  width: 100%;
  padding: 40px 0;
  background-color: #eef0f2;
}
.thumb {
  width: 1100px;
  margin: 0 auto;
  .topThumb {
    position: relative;
    .swiper-button-next {
      position: absolute;
      right: -40px;
      top: 320px;
      width: 24px;
      height: 63px;
      background-image: url(../img/arrow_1.png);
      transform: rotate(180deg);
      // bottom: 0;
      // margin: auto;
    }
    .swiper-button-next:after {
      content: none;
    }
    .swiper-button-prev {
      position: absolute;
      left: -40px;
      top: 320px;
      width: 24px;
      height: 63px;
      background-image: url(../img/arrow_1.png);
      // bottom: 0;
      // margin: auto;
    }
    .swiper-button-prev:after {
      content: none;
    }
  }
  
  .swiper {
    width: 1100px;
    // height: 840px;
    .swiper-slide {
      width: 100%;
      height: 840px;
      img {
        width: 100%;
        max-height: 100%;
      }
      .photoDesc {
        width: 100%;
        height: 132px;
        font-size: 24px;
        line-height: 1.2;
        color: #242424;
        margin-top: 15px;
      }
    }
    
    &.gallery-top {
      height: 80%;
      width: 100%;
    }
    
    &.gallery-thumbs {
      height: 209px;
      
      box-sizing: border-box;
      padding: 40px 0;
      text-align: center;
    }
    &.gallery-thumbs .swiper-slide {
      width: 25%;
      height: 129px;
      opacity: 0.4;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &.gallery-thumbs .swiper-slide-active {
      opacity: 1;
    }
  }
  .gallery-thumbs-con {
    width: calc(100% + 100px);
    margin-left: -50px;
    background-color: #fff;
  }
}

</style>
